"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uint8Array2string = uint8Array2string;
exports.ToBoumWireClaimsV2 = ToBoumWireClaimsV2;
exports.toBoumClaimsParams = toBoumClaimsParams;
exports.FromBoumWireClaimsV2 = FromBoumWireClaimsV2;
const boum_claims_1 = require("./boum-claims");
const boum_right_1 = require("./boum-right");
const boum_v2_1 = require("./boum-v2");
const claims_1 = require("./claims");
function uint8Array2string(val) {
    return btoa(val.reduce((acc, current) => acc + String.fromCharCode(current), ''));
}
function ToBoumWireClaimsV2(claims) {
    const val = {
        rightBits: claims.userRights.val.toBits(),
        tenants: (0, claims_1.sanitizeStringArray)(claims.tenants.val),
        customerTenants: (0, claims_1.sanitizeStringArray)(claims.customerTenants.val),
        operatorTenants: (0, claims_1.sanitizeStringArray)(claims.operatorTenants.val),
        ridepoolingServiceTenants: (0, claims_1.sanitizeStringArray)(claims.ridepoolingServiceTenants.val),
        fleets: (0, claims_1.sanitizeStringArray)(claims.fleets.val),
        serviceAreas: (0, claims_1.sanitizeStringArray)(claims.serviceAreas.val),
    };
    if ((0, claims_1.isSome)(claims.userId)) {
        val.userId = (0, claims_1.toString)(claims.userId);
    }
    if ((0, claims_1.isSome)(claims.backofficeUsername)) {
        val.backofficeUsername = (0, claims_1.toString)(claims.backofficeUsername);
    }
    if ((0, claims_1.isSome)(claims.isSystemUser)) {
        val.isSystemUser = claims.isSystemUser.val;
    }
    const ret = boum_v2_1.BoumV2.encode(val).finish();
    return {
        boV2: uint8Array2string(ret),
    };
}
function decodeToRights(rightBits) {
    const bit2Enum = boum_right_1.BoumRightEnDeCoder.enums().reduce((acc, e) => {
        acc[e.bit()] = e;
        return acc;
    }, []);
    return rightBits.reduce((acc, val8, idx) => {
        const bitIdx = idx * 8;
        for (let bit = 0; bit < 8; bit++) {
            if (val8 & (1 << bit)) {
                if (bit2Enum[bitIdx + bit]) {
                    acc.push(bit2Enum[bitIdx + bit]);
                }
            }
        }
        return acc;
    }, []);
}
function toBoumClaimsParams(base64PB) {
    const boumv2 = boum_v2_1.BoumV2.decode(Uint8Array.from(atob(base64PB || ''), c => c.charCodeAt(0)));
    return {
        userRights: decodeToRights(boumv2.rightBits),
        tenants: boumv2.tenants,
        customerTenants: boumv2.customerTenants,
        operatorTenants: boumv2.operatorTenants,
        ridepoolingServiceTenants: boumv2.ridepoolingServiceTenants,
        fleets: boumv2.fleets,
        serviceAreas: boumv2.serviceAreas,
        userId: boumv2.userId,
        backofficeUsername: boumv2.backofficeUsername,
        isSystemUser: boumv2.isSystemUser,
    };
}
function FromBoumWireClaimsV2(claims, defaults = {}) {
    const withDefaults = { ...toBoumClaimsParams(claims.boV2), ...defaults };
    const ec = new claims_1.ErrorCollector('boum');
    return new boum_claims_1.BoumClaimsImpl(ec, {
        version: 'V2',
        userRights: claims_1.WithDefault.from(boum_right_1.BoumRightEnDeCoder.toPermissions(withDefaults.userRights), boum_right_1.BoumRightEnDeCoder.toPermissions()),
        tenants: claims_1.WithDefault.from(withDefaults.tenants, []),
        customerTenants: claims_1.WithDefault.from(withDefaults.customerTenants, []),
        operatorTenants: claims_1.WithDefault.from(withDefaults.operatorTenants, []),
        ridepoolingServiceTenants: claims_1.WithDefault.from(withDefaults.ridepoolingServiceTenants, []),
        fleets: claims_1.WithDefault.from(withDefaults.fleets, []),
        serviceAreas: claims_1.WithDefault.from(withDefaults.serviceAreas, []),
        userId: claims_1.WithDefault.from(withDefaults.userId, ''),
        backofficeUsername: claims_1.WithDefault.from(withDefaults.backofficeUsername, ''),
        isSystemUser: claims_1.WithDefault.from(withDefaults.isSystemUser, false),
    }, ToBoumWireClaimsV2);
}
//# sourceMappingURL=boum-claims-v2.js.map